module.exports = __webpack_public_path__ + "static/beth-912ad24d732e10fbd62dfd51d893e67f.png";